import { useLoanApplication } from '../../../contexts/LoanApplicationContext';

export default function ProgressIndicator() {
  const { currentStep } = useLoanApplication();

  const steps = [
    { number: 1, label: 'Personal Info', icon: 'ri-user-line' },
    { number: 2, label: 'Loan Details', icon: 'ri-money-dollar-circle-line' },
    { number: 3, label: 'Documents', icon: 'ri-file-list-line' },
    { number: 4, label: 'Review & Submit', icon: 'ri-checkbox-circle-line' }
  ];

  return (
    <nav 
      className="w-full max-w-4xl mx-auto mb-8" 
      aria-label="Application Progress"
      role="navigation"
    >
      <ol className="flex items-center justify-between">
        {steps.map((step, index) => (
          <li key={step.number} className="flex items-center flex-1">
            {/* Step Circle */}
            <div className="flex flex-col items-center flex-shrink-0">
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center font-semibold transition-all ${
                  currentStep === step.number
                    ? 'bg-teal-600 text-white ring-4 ring-teal-100'
                    : currentStep > step.number
                    ? 'bg-teal-600 text-white'
                    : 'bg-gray-200 text-gray-500'
                }`}
                role="img"
                aria-label={`Step ${step.number}: ${step.label} - ${
                  currentStep === step.number 
                    ? 'Current step' 
                    : currentStep > step.number 
                    ? 'Completed' 
                    : 'Not started'
                }`}
              >
                {currentStep > step.number ? (
                  <i className="ri-check-line text-xl" aria-hidden="true"></i>
                ) : (
                  <i className={`${step.icon} text-xl`} aria-hidden="true"></i>
                )}
              </div>
              <p
                className={`mt-2 text-xs font-medium text-center whitespace-nowrap ${
                  currentStep >= step.number ? 'text-teal-600' : 'text-gray-500'
                }`}
              >
                {step.label}
              </p>
            </div>

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div 
                className="flex-1 h-1 mx-2 relative top-[-16px]"
                role="presentation"
              >
                <div
                  className={`h-full rounded transition-all ${
                    currentStep > step.number ? 'bg-teal-600' : 'bg-gray-200'
                  }`}
                  aria-hidden="true"
                ></div>
              </div>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}